import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getSubMenu as getSubMenuApi,
    createSubMenu as createSubMenuApi,
    updateSubMenu as updateSubMenuApi,
    deleteSubMenu as deleteSubMenuApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getSubMenu = createAsyncThunk("SubMenu/getSubMenu", async () => {
    try {
        const response = await getSubMenuApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const createSubMenu = createAsyncThunk("SubMenu/createSubMenu", async (subMenu: any) => {
    try {
        const response = createSubMenuApi(subMenu);
        const data = await response;
        toast.success("SubMenu Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("SubMenu Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateSubMenu = createAsyncThunk("SubMenu/updateSubMenu", async (dataArr: any) => {
    try {
        const response = updateSubMenuApi(dataArr);
        const data = await response;
        toast.success("SubMenu Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("SubMenu Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteSubMenu = createAsyncThunk("SubMenu/deleteSubMenu", async (submenuId: any) => {
    try {
        const response = deleteSubMenuApi(submenuId);
        console.log(response);
        toast.success("SubMenu Deleted Successfully", { autoClose: 2000 });
        return submenuId;
    } catch (error) {
        toast.error("SubMenu Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
